export const Bio = {
  name: "Abdul Rehman",
  roles: [
    "Frontend Developer",
    "MERN Stack Developer",
    "Problem solver",
    "Programmer",
  ],
  description:
    "Instead of trying to be the first in a race, my priority has always been to give my best. This mindset motivates me to step out of my comfort zone and continuously push myself to learn new skills. I firmly believe in consistently challenging myself to improve my knowledge and abilities.",
  github: "https://github.com/a-rehman01",
  email: "arehmana377@gmail.com",
  resume:
    "https://drive.google.com/file/d/1MT8lJsV7wDbfRjz5BHm4CRnu9BWWPH6G/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/abdul-rehman-7024981a1/",
  github: "https://github.com/a-rehman01",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "TypeScript",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/typescript/typescript-original.svg",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOAAAADgCAMAAAAt85rTAAAAh1BMVEX///8Af/8Ad/8AfP8Aev/v+P8Adf8Ae/+Puv8Adv+72P8Ac/87k/8Agf/t9f/6/f/U5v+lyf/m8f+10//H3v/C2/9Tnf9npv/e7P+w0P9+s/9Il/+Ywf8rjP8xkP/A2f8ch//Q4/9zrf94r/+HuP+dxP8JhP9aoP/a6f9Mmv+py/+Tv/8Ab/9IeMWVAAAHEElEQVR4nO2d6XqqMBBAJUQodcG1tlqpS2tre9//+W6oWgWyTAiB4DfnNwaOZiQkk6HTQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQZCm2X5Pu3Wda/Y91zl8Mhoan3KY9AghD8btQJgeAhL5YMVtEgTRp+GXHx9Cj0EGU7N2AHz1g/RUXm8EOry76PnsaHqIjc76SrwTQQI7b1nO18vw+5Djx4SeDifvRuc9ns/KzhsszDu8kFcSXk7kRerfZLsmf9e1MTpx8ifoeSH5MWpLzOOBXE/jEVVYxX+/9q+h0alvBW2F4tcq8DwNwb/eWb0g6z79qkOxuwty55ALjtYke3i1gp7fW1R6V/ygNHcGqWA30zttCLJQjF6Nmrzl7UAK7csEx1FYOLxyQXYFhzejRi8854JPKbjjHW9BkN0VV89GzabE+3zwqQTnPd7hVgRZKO4MQzH3XwgRXBT7pzVBNkaiHwbtzjec4FMJ9rkXY0vQJBQnT4X/QhcF2eitVCjGS5meS4Kp4l47FMe+KPgcFNQPxVl+INKw4FolmIYi/ClcHnyOCrJ+eoSFYvweAZpzTzBVXAKeq79VweeuYBqKY0VL23UEa0pXMKxFkF3WeiZpZ/gpGJeZCw5qEmSjt6eJqJl3zlNARYJ0UZdgqsgPxRdg8JUR9CPht1q9IPs6ve9CE9sEGnwlBKm/NfLTFfS8KBeKw+IjeHWCoi5jU5Cd9POm0zwEGsGnKxj1zZ9K9QXT6cX38/c6HSjHZeUFqfdirFdO8DcUmeKsz52RqEawgt5pIMgukhwoKftZkeDq2mAVcyZGgiYIBZeXu001vfOXTf1+YsHJqctX1TvdE+zMCQ1pZb3TQcHO8Gex11oDbptg9aAgCrZX0De5Rco+7IYgJUk/LDPSPH14nRTXBZ0SjH4nfKHTSFnYjZp9OP4RPSa6IEjPuRvxkug+DvnBZWZjKjB0QfA60TN5gs8m/V795vpAfOR/0gHBcHdzyEyyEpYnO9H/zf+gA4I0m7umXE45k1+qeXRA8AARVC6InSiMktsjyELxqFLkLJe2SVC+KJ0GHyf3ZNoqQW5OzxlB9lDbBDvxjt9Pg/4X9/jWCfJTe8QZfC0UZH8cuanQMBDnYLZSMJvbyoJPkkXbUsFOd3EZvUXyPGhTwfnuacmPbjhlBDudUcIUfeIrZi/NBFm8hz7tmeRbdcoKsms/HhJlArSJYPfyj92TLSyrGZQUBGEgeL3n+k9G1+CmYHbUZHQNVgVfygk+Z8e9Zmkk7gnG+1w20Z0JFp8970qQN3twT4LchIY7Elxwj78fwck/7uH3Iyg4/H4EBbOMZoLcJlEQxvNKb2a7ZYLCnT13Iije2XMXgtL1DJHguDWCis0FbRdULmS0XFC9FFWrIP+7Li8I2NkjFuR/My4Jgnb2tFcwfodlkLZVEJySUatg2XnRAjPwzh5hLQsrgntuo9qCk0/45gJ/JWjEiuCQcrfTaApq7ewR1pP5sCHYeeYNqvQEtXb2UF84FW9HkHtn1hEc6ezs8SNJOrYtQc7YCi6otbNHtn/NpmDxBg0W1NrZI9+BaFUw/3wDFNTa2UND1R5Sq4Lpn/S1fQqpfTRKNHb2QPZCWBZkofi36hEAUvvn/zSCD7SP27Zgmq91mkYJ14CDBXlaPMgGtBfCvmAaigGlwQZSfwwsSAlwmb0OQfbHsVzCKnMBBf0AXJimHkEwMMFgBc8DeW2foF6dNn5BIIcFQ16KpZihYETrqqA8y4sDvw6Cs4KKLK8CbwPRoM9JQV+zSGK+/KHrgv5Ga49qV7hO46og0coRFKdKuyroJxrtyJPd3RQM4RVSLsPfdgn6R2AboA0nDgp6FDb8HMuDz2FBUB+FrNO4KugRZf1v2DqNs4Kqis/xErwr0bAMdXlUY1HZk8TYg08V11Smvoj6aUJUfF1nx6VH9QZFFQJ4HuQWX59oVGBLW2jKD/ZEHxY6mNY6TbQ2rMllAnBOJlv7Rm+dprqyOWUAz6pFyeVngJc/9G5LYzXEF7dmNI/zs73OImmuuFkzaJSDCnv9Rb/XluC7MNGJJz/UKDfAKzDYBJzC+1VQac0qQ0YlS8dJ9aSLpLVTrvifGNUiaQP86Px5KKBEtUjaBJWFIqxUchNoJVqI9Y5OBV+WqWcaijrlyhvhQbt00C00NNyLXAPDhV7poBvKvDKgCbTSLm7oVVqt0Spl7orOB18W3VA0e/FKE2gmr5m+OqcJ4APUakul1sgLKBTJ4bHpCy2PeoAaBtW9gKwJFKHYzuDLIhugRoIiUC1jKpigr+ONqjXBuyvaexFnExQGqHZfpdoE2ddt2H4ZbiNcB6hk0OhcvD1OoRhGD47OSJjDQrF3d8GXw+H5FgRBEARBEARBEARBEARBEARBEARBEARBEMZ/Z7h0SlKcxhsAAAAASUVORK5CYII=",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Graph Ql",
        image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Express Js",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/express/express-original.svg",
      },
      {
        name: "nodemailer",
        image: "https://nodemailer.com/nm_logo_200x136.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image: "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Jest",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/jest/jest-plain.svg",
      },
      {
        name: "Jira",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/jira/jira-original.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://asset.brandfetch.io/idhOXm33Bj/idzKJkR87o.png?updated=1671093046942",
    linkedIn: "https://www.linkedin.com/company/folio3/",
    role: "Senior Software Engineer",
    company: "Folio3",
    date: " January 2024 - Present",
    desc: [
      "1. Working with the team and participating in daily scrum meetings.",
      "2. Developing and customizing an internal product based on MERN Stack.",
      "3. Taking client calls, obtaining their requirements and problems, and then building the solution while working on it with the team",
      "4. Worked with software development and testing team members to design and develop robust solutions to meet client requirements for functionality, scalability, and performance.",
    ],
    skills: [
      "1. JavaScript",
      "2. TypeScript",
      "3. Node Js",
      "4. Next Js",
      "...",
    ],
  },
  {
    id: 0,
    img: "https://asset.brandfetch.io/idhOXm33Bj/idzKJkR87o.png?updated=1671093046942",
    linkedIn: "https://www.linkedin.com/company/folio3/",
    role: "Software Engineer",
    company: "Folio3",
    date: " January 2023 - 2024",
    desc: [
      "1. Working with the team and participating in daily scrum meetings.",
      "2. Developing and customizing an internal product based on MERN Stack.",
      "3. Taking client calls, obtaining their requirements and problems, and then building the solution while working on it with the team",
      "4. Worked with software development and testing team members to design and develop robust solutions to meet client requirements for functionality, scalability, and performance.",
    ],
    skills: [
      "1. JavaScript",
      "2. TypeScript",
      "3. Node Js",
      "4. Next Js",
      "...",
    ],
  },
  {
    id: 0,
    img: "https://chikoo.app/assets/chikoo_logo-0ac8ede2.png",
    linkedIn: "https://www.linkedin.com/company/get-chikoo/",
    role: "Full Stack Developer",
    company: "Chikoo",
    date: "January 2022 - January 2023",
    desc: [
      "1. Mainly focus on the user side and work on improving the user experience and journey to make it easier, faster, and simpler.",
      "2. Participated in code reviews, PR reviews, and refactoring sessions , and received sessions on code cleaning.",
      "3. I am working on integrating payment gateways such as Raast, ChikooPay, and Wallet.",
      "4. Improve website loading time and ensure a smooth checkout process.",
      "5. Agile best practices and project management techniques to ensure timely delivery of the developed solution.",
    ],
    skills: [
      "1. ReactJS",
      "2. Redux",
      "3. NodeJs",
      "4. JavaScript",
      "5. Netsuit",
      "6. GraphQl",
      "7. MongoDB",
      "...",
    ],
  },
  {
    id: 1,
    img: "https://planzdev.com/wp-content/uploads/2021/09/Plan-Z-Dev-NavBar-Logo-Full.png",
    linkedIn: "https://www.linkedin.com/company/plan-z-dev/",
    role: "Full Stack Developer",
    company: "PlanZ",
    date: "November 2020 - January 2022",
    desc: [
      "1. I designed and developed user-friendly websites and worked closely with programmers and clients to meet project requirements, goals, and desired functionality",
      "2. I integrated front-end elements created by front-end developers.",
      "3. I developed APIs and RESTful services.",
    ],
    skills: [
      "1. ReactJS",
      "2. Redux",
      "3. NodeJs",
      "4. HTML",
      "4. CSS",
      "5. JavaScript",
      "6. MongoDB",
      "...",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: require("../images/UniversityOfKarachi.png"),
    school: "University of Karachi",
    date: "May 2017 - May 2022",
    grade: "CGPA: 3.2",
    desc: "I completed my graduation from Karachi University (UBIT), also known as Umaer Basha Institute of Information Technology, where I studied Software Engineering. With the grace of Allah, I secured a 3.2 CGPA.",
    degree: "Bachelor of Computer Science",
  },
  {
    id: 1,
    img: require("../images/NCR-CET-Logo.jpg"),
    school: "NCR-CET College",
    date: "May 2015 - May 2017",
    grade: "80%",
    desc: "I completed my high school education in Class 12 at NCR-CET College, where I studied Science with a focus on Computer Science and achieved an 80+ percentage.",
    degree: "Intermediate",
  },
];
export const certification = [
  {
    id: 0,
    img: require("../images/certification(AWS).png"),
    certificate: "AWS Certified Cloud Practitioner",
    date: "April 2023",
  },
];

export const projects = [
  {
    id: 0,
    title: "Chikoo",
    description:
      "Chikoo is a multi-vendor app where you can digitize your shop with just one click and start selling your products easily. It has 40 thousand merchants who are using this app and selling their services according to their category. You just enter your number with the country code, and your website is created automatically.",
    image: require("../images/chikooapp.png"),
    tags: [
      "React Js",
      "GraphQL",
      "Node Js",
      "Express Js",
      "Context Api",
      "DGraph",
    ],
    category: "all",
    github: "https://github.com/rishavchanda/Podstream",
    webapp: "https://chikoo.app/",
  },
  {
    id: 1,
    title: "Hifazah",
    description:
      "Hifazah is an insurance app where you can insure seven different things. The main feature is that you can customize your own insurance package and easily purchase it. Additionally, you can compare different packages in terms of services and prices.",
    image: require("../images/hifazah.jpg"),
    tags: [
      "Next Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
      "Ant Design",
    ],
    category: "all",
    github: "https://github.com/rishavchanda/Project-Management-App",
    webapp: "https://www.hifazah.com/",
  },
];
